<template>
<div class="chapter">
<div class="inner_page">
<p class="label"><a id="page_xv"></a><a id="page_xvi"></a><a id="pt1"></a><strong><em>Part One</em></strong></p>
<p class="h2a"><strong><em>IN SEARCH OF TASTE AND DISTINCTION 1786–1848</em></strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226473796_07_Pt1.vue?7dc0d9b4